// extracted by mini-css-extract-plugin
export default {"ai-icon":"Fb5BvILNnLTyDBsZQAx3","ai-icon-small":"ENhH2dYXjUj5PmemIFy0"};